import PropTypes from 'prop-types';
import React from 'react';
import {Layout} from '@republic/bits';
import {compose} from '@republic/foundation/lang/function';
import {createComponent, use} from '@republic/react-foundation';
import LoginButton from '../../auth/components/LoginButton';
import AuthStream from '../../auth/streams/AuthStream';
import Copy from '../../copy/components/Copy';
import Heading from '../../copy/components/Heading';
import colors from '../../core/components/colors';
import page from '../../core/enhancers/page';
import AccountBase from './AccountBase';
import Cancellation from './Cancellation';

export default (
    compose(
        page('Cancel Service | Relay'),
        use({authenticated: AuthStream.as(auth => auth.map(auth => !!(auth && auth.id)))}))(
        createComponent(
            'CancellationPage',
            {
                propTypes: {
                    authenticated: PropTypes.bool.isRequired
                }
            },
            ({authenticated}) => (
                <AccountBase>
                    <Layout
                        border={{width: [0, 0, 1, 0], color: colors.gray}}
                        padding={{bottom: 1.5}}
                        margin={{bottom: 2}}>
                        <Heading setting="portal_small">
                            Cancel Service
                        </Heading>
                    </Layout>
                    {authenticated ?
                        <Cancellation /> :
                        <>
                            <Layout padding={{bottom: 2}}>
                                <Copy setting="small" align="center" weight="bold">
                                    You must sign in to view this page.
                                </Copy>
                            </Layout>
                            <LoginButton />
                        </>}
                </AccountBase>))));
